import httpClient from "../../../shared/api/httpClient";

// getConnectUrl é uma chamada AJAX autenticada normal (Authorization: Bearer via
// httpClient) que devolve a URL de consentimento do Google — o browser só navega
// (window.location.href) para essa URL DEPOIS de recebê-la, nunca leva o token de sessão
// na URL (ver PerfilPage.jsx e o comentário em googlecalendar/http.Handlers.Connect).
export const googleCalendarApi = {
  getStatus: () => httpClient.get("/api/v1/integrations/google-calendar/status").then((r) => r.data.dados),
  getConnectUrl: () => httpClient.get("/api/v1/integrations/google-calendar/connect").then((r) => r.data.dados.redirect_url),
  disconnect: () => httpClient.delete("/api/v1/integrations/google-calendar").then((r) => r.data),
};
